export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مكافأة الترحيب"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["جرب حظك!"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لقد فزت"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدر العجلة واحصل على أموال اختبارية لاستكشاف جميع ميزات المنصة."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هذه الأموال مخصصة للاختبار."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انغمس وجرب جميع الميزات."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تدوير"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مطالبة"])}
}